import { gql, useQuery } from "@apollo/client";
import TagManager from 'react-gtm-module';
import Clarity from '@microsoft/clarity';

const GET_GTM_ID = gql`
query getGTMId {
    organisationSettings(where: {settingName: {_eq: "google_tag_manager_code"}}) {
        settingValue
    }
}
`;

const GET_CLARITY_ID = gql`
query getClarityId {
    organisationSettings(where: {settingName: {_eq: "clarity_project_id"}}) {
        settingValue
    }
}
`;

/**
 * Hook to fetch Google Tag Manager ID from organization settings
 * @returns {string|undefined} The Google Tag Manager ID if available
 */
export function useFetchGTMId() {
  const { data } = useQuery(GET_GTM_ID,
    {
      context: {
        headers: {
          'x-hasura-role': 'learner'
        }
      },
    }
  );

  return data?.organisationSettings[0]?.settingValue;
}

/**
 * Hook to fetch Microsoft Clarity ID from organization settings
 * @returns {string|undefined} The Microsoft Clarity project ID if available
 */
export function useFetchClarityId() {
  const { data } = useQuery(GET_CLARITY_ID,
    {
      context: {
        headers: {
          'x-hasura-role': 'learner'
        }
      },
    }
  );

  return data?.organisationSettings[0]?.settingValue;
}

/**
 * Initializes Google Tag Manager with the provided ID
 * @param {string} gtmId - The Google Tag Manager ID to initialize
 * @returns {void}
 */
export function initializeGoogleTagManager(gtmId) {
  if (gtmId) {
    TagManager.initialize({ gtmId });
  }
}

/**
 * Initializes Microsoft Clarity with the provided project ID
 * @param {string} projectId - The Microsoft Clarity project ID to initialize
 * @returns {void}
 */
export function initializeClarity(projectId) {
  if (projectId) {
    Clarity.init(projectId);
  }
} 